// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Belarus from '../_raw/flag/icon_flag_belarus.png';

export default () => <img src={Belarus} alt="Belarus" />;
